"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib"); // @ts-nocheck


var getWindowScroll_1 = tslib_1.__importDefault(require("./getWindowScroll"));

var getWindow_1 = tslib_1.__importDefault(require("./getWindow"));

var instanceOf_1 = require("./instanceOf");

var getHTMLElementScroll_1 = tslib_1.__importDefault(require("./getHTMLElementScroll"));
/**
 * @param node
 */


function getNodeScroll(node) {
  if (node === getWindow_1["default"](node) || !instanceOf_1.isHTMLElement(node)) {
    return getWindowScroll_1["default"](node);
  } else {
    return getHTMLElementScroll_1["default"](node);
  }
}

exports["default"] = getNodeScroll;